import { render } from "./CarrierTable.vue?vue&type=template&id=30f935e0&ts=true"
import script from "./CarrierTable.vue?vue&type=script&lang=ts"
export * from "./CarrierTable.vue?vue&type=script&lang=ts"

import "./CarrierTable.vue?vue&type=style&index=0&id=30f935e0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__